function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRefinementList } from 'react-instantsearch';
import { Button as RKSButton, FormCheckboxes } from '@uncinc/uncinc-react-kitchen-sink';
import SearchBarBase from '../../SearchBar/Base';
import { DEFAULT_TEXT } from '../../../config/constants';
import './style.scss';
const SearchFacetRefinementCheckboxes = props => {
  const {
    t
  } = useTranslation();
  const {
    attribute,
    searchable,
    searchablePlaceholder,
    showMore,
    showMoreButton,
    showMoreText = t(['searchkit.buttons.show_more', DEFAULT_TEXT.BUTTONS.SHOW_MORE]),
    showLessText = t(['searchkit.buttons.show_less', DEFAULT_TEXT.BUTTONS.SHOW_LESS]),
    className,
    itemClassName,
    ...restProps
  } = props;
  const {
    items,
    canToggleShowMore,
    isShowingMore,
    canRefine,
    searchForItems,
    toggleShowMore,
    refine
  } = useRefinementList(props);
  const classNames = c('Searchkit__Facet__RefinementCheckboxes', className);
  const itemClassNames = c('Searchkit__Facet__RefinementCheckboxes__item', itemClassName);
  const Button = showMoreButton || RKSButton;
  const fieldName = "refinementList_".concat(attribute);
  const options = items.map(item => ({
    value: item.value,
    label: /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label",
      "data-facet-label": item.label,
      "data-facet-count": item.count
    }, /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__label"
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__count"
    }, item.count)),
    disabled: item.count === 0
  }));
  if (!canRefine) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Facet__RefinementCheckboxes__wrapper"
  }, /*#__PURE__*/React.createElement(FormCheckboxes, _extends({}, restProps, {
    fieldName: fieldName,
    options: options,
    wrapperClassName: classNames,
    className: itemClassNames,
    onChange: value => {
      refine(value);
    }
  })), searchable && /*#__PURE__*/React.createElement(SearchBarBase, {
    placeholder: searchablePlaceholder,
    autoSearch: true,
    className: "Searchkit__Facet__RefinementCheckboxes__searchbar",
    onSubmit: query => {
      searchForItems(query);
    }
  }), showMore && canToggleShowMore && /*#__PURE__*/React.createElement(Button, {
    className: "Searchkit__Facet__RefinementCheckboxes__showMore",
    onClick: () => {
      toggleShowMore();
    }
  }, isShowingMore ? showLessText : showMoreText));
};
export default SearchFacetRefinementCheckboxes;